import { GitBranch, Bot, Cog } from 'lucide-react';
import { TrackClassificationEvent as TrackClassificationEventType } from '../types';
import { Badge } from '@/components/ui/badge';
import EventShell from './EventShell';

interface Props {
  event: TrackClassificationEventType;
}

export default function TrackClassificationEvent({ event }: Props) {
  const isAI = event.payload.classification_source === 'ai';

  return (
    <EventShell
      color="violet"
      icon={<GitBranch className="w-3.5 h-3.5" />}
      title="Track Classification"
      timestamp={event.created_at}
    >
      <div className="flex items-center gap-1 flex-wrap">
        {event.payload.track_path.map((trackName, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && <span className="mx-0.5 text-muted-foreground">→</span>}
            <span className={index === event.payload.track_path.length - 1 ? 'font-semibold text-violet-500' : ''}>
              {trackName}
            </span>
          </span>
        ))}
      </div>

      <div className="flex items-center gap-2 pt-0.5">
        <Badge
          variant="outline"
          className={`text-[10px] h-4 px-1.5 gap-0.5 ${isAI ? 'border-blue-500/50 text-blue-500' : 'border-muted-foreground/50 text-muted-foreground'}`}
        >
          {isAI ? <><Bot className="w-3 h-3" /> AI</> : <><Cog className="w-3 h-3" /> Logical</>}
        </Badge>
        {event.payload.previous_track_system_name && <span className="text-[10px]">from previous track</span>}
      </div>

      {event.payload.reason && <p className="italic">"{event.payload.reason}"</p>}
    </EventShell>
  );
}
